module.exports = __webpack_public_path__ + "img/premium.5edcc204.svg";